// extracted by mini-css-extract-plugin
export default {"page":"yfa-z","cartModal":"zfa-z","checkout":"Afa-z","placeholder":"Bfa-z","account":"Cfa-z"};